import { Link, useLocation, useNavigate } from "react-router-dom";
import React, {useEffect, useState, useRef} from 'react';
import { useSelector } from 'react-redux';
import LangSwitch from "../languageSwitch/langSwitch";
import './navbar.css'
import Icon from "../icon/icon"
import Devider from "../devider/Devider";
import { cvDownload, cvDownload_en } from '../../conexiones/varConexiones';
import navbarWords from "./navbardictionary";
import { useParams } from "react-router-dom";

const colors = {
            white:'rgba(255, 255, 255, 1)',
            gray:'rgba(192, 192, 192, 1)',
            violet:'rgba(119, 54, 215, 1)',
            calipso:'rgba(52, 149, 215, 1)',
            carbon:'rgba(51, 51, 51, 1)'
    };
const Swipt = (props) => {
    const lang = useSelector((state) => state.lang.lang);
    const menuRef = useRef(null);
    const resumFunc = () => {
            const link = document.createElement("a");
            const ruta = lang === 'es' ? cvDownload : cvDownload_en;
            link.href = ruta;
            link.download = "";   // permite descargar el archivo
            link.target = "_blank";
            link.click();
        }
    useEffect(() => {
        function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            props.onClick(0)
        }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);
    return (
        <div ref={menuRef} className="swipt">
            <div className="swipt-option" onClick={()=>resumFunc()}><p>{navbarWords.swipt[lang]}</p><Icon source={'file_save'} color={colors.white}/></div>
            <Devider direction={'horizontal'}></Devider>
            <div className="swipt-option">
                <LangSwitch></LangSwitch>
            </div>
        </div>
    )
}
const Navbar =({scroll, refs, requestScroll})=>{
    const { mainRef, expRef } = refs;
    const lang = useSelector((state) => state.lang.lang);
    const [estadoMore,showMore] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const pages = ['/Casos/']
    const ocultar = pages.some(ruta => location.pathname.startsWith(ruta));
    const handleRequest = (target, route = null) => {
        if (route) {
            navigate(route);
        }

        if (typeof requestScroll === 'function') {
            requestScroll(target);
            return;
        }

        if (typeof scroll === 'function') {
            scroll(target === 'reset' ? 'reset' : (target === 'exp' ? expRef : mainRef));
        }
    };
    /* const isDetailPage = location.pathname.startsWith('/Casos/'); */
    return(
        <div className="navBar-content" style={{display:ocultar?'none':'block'}}>
            {estadoMore === 1 ? <Swipt onClick={showMore}></Swipt>:null}
            <div className="navBar">
                <div
                    className={`vavBar-option ${location.pathname === '/Home' || location.pathname === '/' || location.pathname === ''?'-on':''}`}
                    onClick={() => handleRequest('reset', '/Home')}
                >
                    <Icon source={'home'} color={colors.white}/>
                    <caption className="vavBar-option-text">{navbarWords.opt1[lang]}</caption>
                </div>
                <div
                    className="vavBar-option"
                    onClick={() => handleRequest('main', '/Home')}
                >
                    <Icon source={'business'} color={colors.white}/>
                    <caption className="vavBar-option-text">{navbarWords.opt2[lang]}</caption>
                </div>
                <div
                    className={`vavBar-option ${location.pathname.startsWith('/About')?'-on':''}`}
                    onClick={() => handleRequest('exp', '/About')}
                >
                    <Icon source={'clinical'} color={colors.white}/>
                    <caption className="vavBar-option-text">{navbarWords.opt3[lang]}</caption>
                </div>
                <div
                    className={`vavBar-option ${location.pathname.startsWith('/Contacto')?'-on':''}`}
                    onClick={() => handleRequest('contact', '/Contacto')}
                >
                    <Icon source={'chat'} color={colors.white}/>
                    <caption className="vavBar-option-text">{navbarWords.opt4[lang]}</caption>
                </div>
                {estadoMore === 1? <div className="vavBar-option --active" onClick={()=>showMore(0)}><Icon source={'cancel'} color={colors.white}/></div>:
                <div className="vavBar-option" onClick={()=>showMore(1)}><Icon source={'more_vert'} color={colors.white}/></div>}
            </div>
        </div>
    )
}
export default Navbar; 